import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { I18n } from "aws-amplify/utils";
import {withRouter} from "./Utils";

// <title> is otherwise frozen at the value baked into public/index.html for every route (WCAG
// 2.4.2) - this is an SPA, so nothing else updates it as the user navigates between screens.
const ROUTE_TITLE_KEYS = {
    "/": "menu.accueil",
    "/profile": "account",
    "/candidate-schedule": "menu.agenda",
    "/candidate-excuses": "menu.excuses",
    "/candidate-history": "menu.historique",
    "/inscription": "menu.inscription",
    "/formateur-schedule": "menu.agenda",
    "/formateur-declaration-frais": "menu.declarationfrais",
    "/accessibilite": "menu.accessibilite",
};

function pageTitleForPath(pathname) {
    if (ROUTE_TITLE_KEYS[pathname]) {
        return I18n.get(ROUTE_TITLE_KEYS[pathname]);
    }
    if (pathname.startsWith("/presence/")) {
        return I18n.get("pagetitle.presence");
    }
    return null;
}

const ScrollToTop = (props) => {

    let location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
        const pageTitle = pageTitleForPath(location.pathname);
        document.title = pageTitle ? `${pageTitle} - ${I18n.get("pagetitle.suffix")}` : I18n.get("pagetitle.suffix");
        // Route changes are SPA navigation, not a real page load, so nothing normally tells
        // assistive tech a new "page" started. Moving focus to the main landmark (WCAG 2.4.3)
        // means a screen reader announces it and keyboard users don't stay stranded on a link
        // that's no longer part of the new view.
        const main = document.getElementById('main-content');
        if (main) {
            main.focus();
        }
    }, [location]);

    return props.children;
}

export default withRouter(ScrollToTop);
